/* flag-actions.tsx generated by @compiled/babel-plugin v3.0.2 */
/* eslint-disable @atlaskit/design-system/no-nested-styles */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3rjf849EAj._3rjf849EAj%7Btransform%3AtranslateX(-2px)%7D%0Aa._2g5bSc9EAj._2g5bSc9EAj%7Btransform%3AtranslateX(-2px)%7D%0A._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._1zBHawbfve._1zBHawbfve%7Bbackground%3Avar(--bg-color)%7D%0Aa._1Zh9sPbfve._1Zh9sPbfve%7Bbackground%3Avar(--bg-color)%7D%0A._4vhRtvWhvE._4vhRtvWhvE%7Bcolor%3Avar(--color)%21important%7D%0Aa._1KLLevWhvE._1KLLevWhvE%7Bcolor%3Avar(--color)%21important%7D%0A._2yzFFQf7mX._2yzFFQf7mX%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D%0Aa._1e2Yfgf7mX._1e2Yfgf7mX%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D%0A._1DQB6798eZ._1DQB6798eZ%3Aactive%7Btext-decoration-color%3AcurrentColor%7D%0A._42kVG698eZ._42kVG698eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D%0Aa._0yfzw298eZ._0yfzw298eZ%3Aactive%7Btext-decoration-color%3AcurrentColor%7D%0Aa._0tvG6s98eZ._0tvG6s98eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D%0A._2T5IMK0Rl6._2T5IMK0Rl6%3Aactive%7Btext-decoration-line%3Aunderline%7D%0A._42n1kX0Rl6._42n1kX0Rl6%3Ahover%7Btext-decoration-line%3Aunderline%7D%0Aa._0mPUgm0Rl6._0mPUgm0Rl6%3Aactive%7Btext-decoration-line%3Aunderline%7D%0Aa._437BtI0Rl6._437BtI0Rl6%3Ahover%7Btext-decoration-line%3Aunderline%7D%0A._06dOVI6wH8._06dOVI6wH8%3Aactive%7Btext-decoration-style%3Asolid%7D%0A._3kRhep6wH8._3kRhep6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D%0Aa._0JO6Ak6wH8._0JO6Ak6wH8%3Aactive%7Btext-decoration-style%3Asolid%7D%0Aa._4d2m5x6wH8._4d2m5x6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D%0A._1YWIj4XiNI._1YWIj4XiNI%3Ahover%7Bbackground-color%3Avar(--bg-color-hover)%7D%0A._2p7eIBBVOI._2p7eIBBVOI%3Aactive%7Bbackground-color%3Avar(--bg-color-active)%7D%0A._3gZsD7AASz._3gZsD7AASz%7Bpadding-top%3A0%21important%7D%0Aa._17zPT6AASz._17zPT6AASz%7Bpadding-top%3A0%21important%7D%0A._27WIHEWfES._27WIHEWfES%7Bpadding-right%3Avar(--ds-space-100%2C8px)%21important%7D%0Aa._3CVxu7WfES._3CVxu7WfES%7Bpadding-right%3Avar(--ds-space-100%2C8px)%21important%7D%0A._11DXJJAASz._11DXJJAASz%7Bpadding-bottom%3A0%21important%7D%0Aa._0QO5anAASz._0QO5anAASz%7Bpadding-bottom%3A0%21important%7D%0A._4GiLnvWfES._4GiLnvWfES%7Bpadding-left%3Avar(--ds-space-100%2C8px)%21important%7D%0Aa._2k3Be9WfES._2k3Be9WfES%7Bpadding-left%3Avar(--ds-space-100%2C8px)%21important%7D%0A._27WIHEAASz._27WIHEAASz%7Bpadding-right%3A0%21important%7D%0Aa._3CVxu7AASz._3CVxu7AASz%7Bpadding-right%3A0%21important%7D%0A._4GiLnvAASz._4GiLnvAASz%7Bpadding-left%3A0%21important%7D%0Aa._2k3Be9AASz._2k3Be9AASz%7Bpadding-left%3A0%21important%7D%0A._3KzIDNAASz._3KzIDNAASz%7Bpadding-block-end%3A0%21important%7D%0Aa._4r9gguAASz._4r9gguAASz%7Bpadding-block-end%3A0%21important%7D%0A._14OR94AASz._14OR94AASz%7Bpadding-block-start%3A0%21important%7D%0Aa._3ifz2HAASz._3ifz2HAASz%7Bpadding-block-start%3A0%21important%7D%0A._38CysdWfES._38CysdWfES%7Bpadding-inline-end%3Avar(--ds-space-100%2C8px)%21important%7D%0Aa._4y9fntWfES._4y9fntWfES%7Bpadding-inline-end%3Avar(--ds-space-100%2C8px)%21important%7D%0A._0Jp6tVWfES._0Jp6tVWfES%7Bpadding-inline-start%3Avar(--ds-space-100%2C8px)%21important%7D%0Aa._0YkdVFWfES._0YkdVFWfES%7Bpadding-inline-start%3Avar(--ds-space-100%2C8px)%21important%7D");










































import { type CSSProperties, type ComponentType, type FC } from 'react';
import type { CustomThemeButtonProps } from '@atlaskit/button/custom-theme-button-types';
import Button from '@atlaskit/button/custom-theme-button/custom-theme-button';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { actionTextColor } from './action-text-color';
import { DEFAULT_APPEARANCE } from './constants';
import { actionBackgroundColor } from './theme';
import type { ActionsType, AppearanceTypes } from './types';
type FlagActionsProps = {
  appearance: AppearanceTypes;
  actions: ActionsType;
  linkComponent?: ComponentType<CustomThemeButtonProps>;
  testId?: string;
};
const buttonStylesOld = null;
const buttonStyles = null;
const fontStyles = null;
const appearanceNormalButtonStyles = null;
const appearanceBoldButtonStyles = null;
const appearanceNormalActionsContainerStyles = null;
const FlagActions: FC<FlagActionsProps> = props => {
  const {
    appearance = DEFAULT_APPEARANCE,
    actions = [],
    linkComponent,
    testId
  } = props;
  if (!actions.length) {
    return null;
  }
  const isBold = appearance !== DEFAULT_APPEARANCE;
  return <span className={ax([!isBold && "_3rjf849EAj _2g5bSc9EAj", "_2sNsIgmnOE"])}>
			<Inline space="space.100" shouldWrap alignBlock="center" separator={isBold ? undefined : '·'} testId={testId && `${testId}-actions`}>
				{actions.map((action, index) => fg('platform_dst_flag_action_padding_fix') ? <Button onClick={action.onClick} href={action.href} target={action.target} appearance={isBold ? 'default' : 'link'} component={linkComponent} spacing="compact" testId={action.testId} key={index} style={({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        '--color': actionTextColor[appearance],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        '--bg-color': actionBackgroundColor[appearance].default,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        '--bg-color-hover': actionBackgroundColor[appearance].pressed,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        '--bg-color-active': actionBackgroundColor[appearance].active
      } as CSSProperties)} className={ax(["_1zBHawbfve _1Zh9sPbfve _4vhRtvWhvE _1KLLevWhvE _2yzFFQf7mX _1e2Yfgf7mX _1DQB6798eZ _42kVG698eZ _0yfzw298eZ _0tvG6s98eZ _2T5IMK0Rl6 _42n1kX0Rl6 _0mPUgm0Rl6 _437BtI0Rl6 _06dOVI6wH8 _3kRhep6wH8 _0JO6Ak6wH8 _4d2m5x6wH8 _1YWIj4XiNI _2p7eIBBVOI", isBold ? "_3gZsD7AASz _17zPT6AASz _27WIHEWfES _3CVxu7WfES _11DXJJAASz _0QO5anAASz _4GiLnvWfES _2k3Be9WfES" : "_3gZsD7AASz _17zPT6AASz _27WIHEAASz _3CVxu7AASz _11DXJJAASz _0QO5anAASz _4GiLnvAASz _2k3Be9AASz"])}>
							{action.content}
						</Button> : <Button onClick={action.onClick} href={action.href} target={action.target} appearance={isBold ? 'default' : 'link'} component={linkComponent} spacing="compact" testId={action.testId} key={index} style={({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        '--color': actionTextColor[appearance],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        '--bg-color': actionBackgroundColor[appearance].default,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        '--bg-color-hover': actionBackgroundColor[appearance].pressed,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        '--bg-color-active': actionBackgroundColor[appearance].active
      } as CSSProperties)} className={ax(["_1zBHawbfve _1Zh9sPbfve _4vhRtvWhvE _1KLLevWhvE _2yzFFQf7mX _1e2Yfgf7mX _3KzIDNAASz _4r9gguAASz _14OR94AASz _3ifz2HAASz _38CysdWfES _4y9fntWfES _0Jp6tVWfES _0YkdVFWfES _1DQB6798eZ _42kVG698eZ _0yfzw298eZ _0tvG6s98eZ _2T5IMK0Rl6 _42n1kX0Rl6 _0mPUgm0Rl6 _437BtI0Rl6 _06dOVI6wH8 _3kRhep6wH8 _0JO6Ak6wH8 _4d2m5x6wH8 _1YWIj4XiNI _2p7eIBBVOI", !isBold && "_3gZsD7AASz _17zPT6AASz _27WIHEAASz _3CVxu7AASz _11DXJJAASz _0QO5anAASz _4GiLnvAASz _2k3Be9AASz"])}>
							{action.content}
						</Button>)}
			</Inline>
		</span>;
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default FlagActions;